<template>
  <v-container class="pa-0 ma-0" fluid>
    <v-toolbar flat color="toolbar">
      <v-toolbar-title class="ml-2 title">
        Recap Additions
      </v-toolbar-title>
    <v-divider vertical inset class="mx-4" />
    <v-row dense class="align-center d-flex">
      <v-col cols="2" class="py-0">
        <v-autocomplete
          v-model="searchParams.billing_year_id"
          :items="billingYears"
          item-text="constant"
          item-value="id"
          prepend-inner-icon='mdi-filter-outline'
          dense
          solo
          flat
          outlined
          placeholder="Year"
          style="height: 40px;"
          :menu-props="{ maxHeight: 260, rounded: '' }"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="2" class="py-0">
        <v-autocomplete
          v-model="searchParams.billing_period_id"
          :items="billingPeriods"
          item-text="constant"
          item-value="id"
          prepend-inner-icon='mdi-filter-outline'
          dense
          solo
          flat
          outlined
          placeholder="Period"
          style="height: 40px;"
          :menu-props="{ maxHeight: 260, rounded: '' }"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="2" class="py-0">
        <v-autocomplete
          v-model="searchParams.recap_component_id"
          :items="recapComponents"
          item-text="name"
          item-value="id"
          prepend-inner-icon='mdi-filter-outline'
          dense
          solo
          flat
          outlined
          placeholder="Component"
          style="height: 40px;"
          :menu-props="{ maxHeight: 260, rounded: '' }"
          clearable
        >
        </v-autocomplete>
      </v-col>
      <v-col cols="2" class="py-0">
        <v-text-field
          v-model="searchParams.store_number"
          prepend-inner-icon='mdi-filter-outline'
          dense
          solo
          flat
          outlined
          placeholder="Store #"
          style="height: 40px;"
          clearable
        >
        </v-text-field>
      </v-col>
      <v-col cols="2" class="py-0">
        <v-text-field
          v-model="searchParams.comment"
          prepend-inner-icon='mdi-filter-outline'
          dense
          solo
          flat
          outlined
          placeholder="Comment"
          style="height: 40px;"
          clearable
        >
        </v-text-field>
      </v-col>
      <v-col style="display: grid; justify-content: flex-end; grid-auto-flow: column; grid-column-gap: 12px">
        <v-btn
          color="accent"
          :disabled="!(searchParams.billing_year_id && searchParams.billing_period_id)"
          @click="DownloadRecapAdditions">
          <v-icon>mdi-file-download-outline</v-icon>
        </v-btn>
        <v-btn
          color="primary"
          @click="component='RecapAdditionModal', modal=true">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    </v-toolbar>
      <v-divider></v-divider>
      <v-data-table
        dense
        :items="recapAdditions"
        :items-per-page.sync="pageSize"
        :headers="headers"
        :height="tableSize"
        :loading="loading"
        item-key="id"
        :style="{'position': 'relative', 'z-index': '1'}"
        fixed-header
        hide-default-footer>
        <template #[`item.amount`]="{ item }">
          <div>{{ '$' + formatCurrencyDisplay(item.amount) }}</div>
        </template>
        <template #[`item.actions`]="{ item }">
        <v-menu open-on-click transition="slide-x-transition" bottom right offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-card class="mx-auto" max-width="300" tile>
            <v-list dense>
              <v-list-item-group color="primary">
                <v-list-item
                  v-for="(action, i) in actions"
                  :key='i'
                  @click="selectedRecapAddition=item, component=action.component, modal=true">
                  <v-list-item-action>
                    <v-icon>
                      {{ action.icon }}
                    </v-icon>
                  </v-list-item-action>
                  <v-list-item-action>
                    <v-list-item-title>
                      {{ action.description }}
                    </v-list-item-title>
                  </v-list-item-action>
                </v-list-item>
              </v-list-item-group>
            </v-list>
          </v-card>
        </v-menu>
      </template>
      </v-data-table>
      <v-divider/>
      <v-toolbar flat color="#fafafa">
        <v-row align="center" justify="end">
          <v-col cols="2" style="max-width:150px;">
            <v-select class="mt-8" dense :items="pageSizes" label="Items Per Page" select v-model="pageSize"
              :menu-props="{ top: true, offsetY: true, maxHeight: 500 }">
            </v-select>
          </v-col>
          <v-btn icon large @click="previous()" :disabled="disablePrevious" class="mx-2">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <small>Page {{page}}</small>
          <v-btn icon large @click="next()" :disabled="disableNext" class="mx-2">
            <v-icon>mdi-chevron-right</v-icon>
          </v-btn>
        </v-row>
      </v-toolbar>
      <Component
        v-if="modal"
        :is="component"
        :value.sync="modal"
        :selectedRecapAddition="selectedRecapAddition"
        @close="closeModal"
      />
  </v-container>
</template>
<script>
// import Party from '@/axios/party'
import RecapAdditions from '@/axios/recap-additions'
import DeleteRecapAddition from '@/components/RecapAdditions/DeleteRecapAddition.vue'
const RecapAdditionModal = () => import('@/components/RecapAdditions/RecapAdditionModal.vue')
import { format } from '@/mixins/format'
import { fullWidth } from '@/mixins/fullWidth'
import { displayAlert } from '@/mixins/displayAlert'
import { dateFormat } from '@/mixins/date-format'
import { userAccess } from '@/mixins/user-access'
export default {
  data () {
    return {
      selectedRecapAddition: null,
      recapAdditions: [],
      actions: [
        {
          description: 'Edit',
          component: 'RecapAdditionModal',
          icon: 'mdi-information-variant'
        },
        {
          description: 'Delete',
          component: 'DeleteRecapAddition',
          icon: 'mdi-trash-can'
        }
      ],
      searchParams: {},
      component: '',
      modal: false,
      loading: true,
      page: 1,
      pageSize: 50,
      pageSizes: [50, 100],
    }
  },
  name: 'Recap Additions',
  mixins: [format, fullWidth, displayAlert, dateFormat, userAccess],
  components: { RecapAdditionModal, DeleteRecapAddition },
  async created () {
    this.nonTableHeight = 228
    if (this.billingPeriods.length === 0 && this.billingYears.length === 0) {
      this.$store.dispatch('getBillingYears')
      this.$store.dispatch('getBillingPeriods')
      this.$store.dispatch('getRecapComponents')
      this.$store.dispatch('getRecapAdditionStatuses')
      await this.$store.dispatch('getStores')
    }
    await this.getRecapAdditions()
  },
  computed: {
    headers () {
      return [
        { class:'accent white--text' },
        { text: 'Year', class:'accent white--text', value: 'billing_year', width:'auto' },
        { text: 'Period', class:'accent white--text',  value: 'billing_period', align:'center', width:'auto' },
        { text: 'Recap Component', class:'accent white--text',  value: 'recap_component', align:'center', width:'auto' },
        { text: 'Store Name', class:'accent white--text',  value: 'store_name', align:'center', width:'auto' },
        { text: 'Amount', class:'accent white--text',  value: 'amount',  align:'center', width:'auto' },
        { text: 'Comment', class:'accent white--text',  value: 'comment',  align:'center', width:'auto'},
        { text: 'Actions', class:'accent white--text',  value: 'actions', sortable: false, align:'center', width:'auto'}
      ]
    },
    billingPeriods () {
      return this.$store.getters.billingPeriods || []
    },
    billingYears () {
      return this.$store.getters.billingYears || []
    },
    recapComponents () {
      const components = this.$store.getters.recapComponents
      if (components?.length > 0) {
        return components.filter(comp => comp.component_type === 'MANUAL')
      }
      return []
    },
    stores () {
      return this.$store.getters.stores || []
    },
    offset () {
      return (this.page - 1) * this.pageSize
    },
    disablePrevious () {
      return this.offset === 0
    },
    disableNext () {
      return this.recapAdditions.length < this.pageSize
    },
  },
  watch: {
    searchParams: {
      handler() {
        this.page = 1
        this.getRecapAdditions()
      },
      deep: true
    },
    pageSize: {
      handler() {
        this.page = 1
        this.getRecapAdditions()
      }
    }
  },
  methods: {
    async getRecapAdditions () {
      this.loading = true
      const params = {
        limit: this.pageSize,
        offset: this.offset,
        ...Object.fromEntries(Object.entries(this.searchParams).filter(([_, v]) => _ && v ))
      }
      params.component_type = 'MANUAL'
      try {
        const { data } = await RecapAdditions.getList(params)
        data.map(ra => {
          ra.billing_year = this.billingYears.find(by => by.id === ra.billing_year_id)?.constant
          ra.billing_period = this.billingPeriods.find(bp => bp.id === ra.billing_period_id)?.constant
          ra.recap_component = this.recapComponents.find(rc => rc.id === ra.recap_component_id)?.name
          const party = this.stores.find(store => store.id === ra.party_id)
          ra.party = party
          ra.store_name = party?.name
          return ra
        })
        this.recapAdditions = data
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    async DownloadRecapAdditions () {
      this.loading = true
      const params = {
        limit: 500,
        ...Object.fromEntries(Object.entries(this.searchParams).filter(([_, v]) => _ && v ))
      }
      params.component_type = 'MANUAL'
      try {
        const res = await RecapAdditions.downloadRecapAdditions(params)
        location.href = res.data;
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    },
    closeModal (update = false) {
      this.modal = false
      this.selectedRecapAddition = null
      if (update) {
        this.getRecapAdditions()
      }
    },
    previous() {
      if (this.page > 1) {
        this.page -= 1
        this.getRecapAdditions()
      }
    },
    next() {
      if (!this.disableNext) {
        this.page += 1
        this.getRecapAdditions()
      }
    },
  }
}
</script>